export enum CustomEntitiesEnum {
  Auth = 'Auth',
  Users = 'Users',
  Terms = 'Terms',
}
